import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';

import EmptyStar from '../../../assets/images/EmptyStar.svg';
import Star from '../../../assets/images/Star.svg';

const TotalStars = ({ reviews }) => {
  const intl = useIntl();
  const [relativeFrequencies, setRelativeFrequencies] = useState({});
  const [totalRatings, setTotalRatings] = useState(0);
  const [ratingCounts, setRatingCounts] = useState([0]);
  let ratings = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

  useEffect(() => {
    if (reviews?.length > 0) {
      ratings = reviews
        .map(review => {
          return review.reviewsAmountByRating;
        })
        .reduce((a, b) => {
          for (const [rating, frequency] of Object.entries(b)) {
            if (!a[rating]) {
              a[rating] = 0;
            }
            a[rating] += frequency;
          }
          return a;
        }, {});
    }

    setRatingCounts(Object.values(ratings).reverse());
  }, [reviews]);

  useEffect(() => {
    const mostFrequentRating = Math.max(...ratingCounts);
    let calculatedRelativeFrequencies = {};
    for (let i = 4; i >= 0; i--) {
      calculatedRelativeFrequencies[i] = Math.floor((ratingCounts[i] / mostFrequentRating) * 100);
    }

    setRelativeFrequencies(calculatedRelativeFrequencies);
    setTotalRatings(ratingCounts.reduce((a, b) => a + b));
  }, [ratingCounts]);

  const renderStars = value => {
    let starIcons = [];
    for (let i = 0; i < value; i++) {
      starIcons.push(<img className="w-5 h-auto mr-1.5" key={i} src={Star} alt="" />);
    }
    for (let i = value; i < 5; i++) {
      starIcons.push(<img className="w-5 h-auto mr-1.5" key={i} src={EmptyStar} alt="" />);
    }
    return <>{starIcons}</>;
  };

  return (
    <>
      <div className="flex flex-col justify-start flex-1 h-full w-full">
        <div className="pb-4 border-b border-solid border-slate-100 mb-6">
          <div className="font-bold text-lg text-slate-800">
            {intl.formatMessage(messages.starRatings)}
          </div>
        </div>
        <div className="flex flex-col flex-1">
          {ratingCounts.map((rating, i) => {
            return (
              <div className="flex flex-row w-full mb-5 justify-between items-center" key={i}>
                <div className="mr-6 flex flex-row items-center shrink-0">{renderStars(5 - i)}</div>
                <div className="h-2 w-full flex bg-slate-200 rounded-full mr-4 lg:mr-0 self-center">
                  <span
                    className="flex h-full rounded-full bg-gradient-to-r from-amber-400 to-amber-500"
                    style={{ width: `${relativeFrequencies[i] || 1}%` }}
                  />
                </div>
                <span className="font-bold text-right text-slate-700 text-base min-w-[30px] lg:ml-6">
                  {rating}
                </span>
              </div>
            );
          })}
        </div>
        <div className="border-t border-solid border-slate-100 pt-4 flex flex-row justify-end mt-auto">
          <div className="font-bold text-lg text-slate-800">
            {intl.formatMessage(messages.totalStars)}: {totalRatings}
          </div>
        </div>
      </div>
    </>
  );
};

export default TotalStars;
